/**
 * Sanitize untrusted HTML before rendering in an iframe.
 * Removes script elements, on* event handlers, and javascript: URLs.
 */
export function sanitizeHtml(html: string): string {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	// Remove all <script> elements
	for (const script of Array.from(doc.querySelectorAll('script'))) {
		script.remove();
	}

	// Walk all elements
	for (const el of Array.from(doc.querySelectorAll('*'))) {
		// Remove on* event handler attributes
		for (const attr of Array.from(el.attributes)) {
			if (attr.name.startsWith('on')) {
				el.removeAttribute(attr.name);
			}
		}

		// Remove javascript: URLs from href and src
		for (const urlAttr of ['href', 'src']) {
			const val = el.getAttribute(urlAttr);
			if (val && val.trim().toLowerCase().startsWith('javascript:')) {
				el.removeAttribute(urlAttr);
			}
		}
	}

	return doc.documentElement.outerHTML;
}
